import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyEntitySalesCreditLimitsContainerModel } from "../../../../../../models/aggregates/company";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class CompanyEntitySalesCreditLimitService extends BaseApiTemplateService<CompanyEntitySalesCreditLimitsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "company-entity-sales-credit-limits/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "company-entity-sales-credit-limits/backoffice-ep";
    this.httpClient = http;
  }
}
